import { HTMLAttributes } from 'react';

import { cn } from '@web/lib/shadcn';

function Skeleton({ className, ...props }: HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      className={cn(
        'bg-muted-foreground/30 animate-pulse rounded-md',
        className,
      )}
      {...props}
    />
  );
}

export { Skeleton };
